// src/Home.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import mickeyCircle from './mickeyCircle.png';
import clientellImage from './clientell.png';
import './Home.css';
import Directions from './Directions';
import DownloadHomeSection from './DownloadHomeSection';
import Reviews from './reviews';
import Contact from './contact';
import Details from './Details';

const TOAST_ORDER_URL = 'https://order.toasttab.com/online/mickey-subs-2';

const Home = () => {
  const openOnlineOrdering = () => {
    window.open(TOAST_ORDER_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="home-wrapper">
      <section className="home-hero">
        <div className="home-card">
          {/* Gray rounded header area with the circle image */}
          <div className="home-card-header">
            <img src={mickeyCircle} alt="Mickey" className="home-badge" />
          </div>

          {/* White body with title, subtitle, and CTA */}
          <div className="home-card-body">
            <p className="home-title">Want to place an order?</p>
            <p className="home-subtitle" style={{ color: '#000' }}>
              Start your <strong style={{ color: '#3AC28E', fontWeight: 'bold' }}>pick up</strong> order now!
            </p>
            <Button
              variant="contained"
              className="order-cta"
              onClick={openOnlineOrdering}
            >
              Order Now
            </Button>
          </div>
        </div>
      </section>
      <Details/>
      <Reviews />
      <div className="divider"></div>
      <DownloadHomeSection />
      <div className="divider"></div>   

      {/* Directions below the hero */}
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Directions
          address="5250 Bridge St, Tampa, FL 33611"
          label="Get Directions"
        />
      </div>

      <footer className="site-footer">
        <div className="site-footer__content">
          <div className="site-footer__text">
            <div className="site-footer__actions">
              <Link to="/privacy" className="site-footer__link">Privacy Policy</Link>
              <span className="site-footer__separator">|</span>
              <Link to="/download" className="site-footer__link">Download App</Link>
              <span className="site-footer__separator">|</span>
              <Link to="/delete-account" className="site-footer__link">Delete Account</Link>
            </div>
            <div className="site-footer__divider" aria-hidden="true" />
            <p className="site-footer__credit">Website made by Clientell Software Solutions LLC</p>
            <p className="site-footer__promo">
              Want to build an app or website for your business? Visit{' '}
              <a href="https://clientellapps.com" target="_blank" rel="noopener noreferrer" className="site-footer__promo-link">
                clientellapps.com
              </a>
            </p>
          </div>
          <div className="site-footer__divider" aria-hidden="true" />
          <img src={clientellImage} alt="Clientell" className="site-footer__image" />
        </div>
      </footer>
    </div>   
  );
};

export default Home;
